import { render, staticRenderFns } from "./ModuleQuestionComponent.vue?vue&type=template&id=c8923daa&scoped=true"
import script from "./ModuleQuestionComponent.vue?vue&type=script&lang=js"
export * from "./ModuleQuestionComponent.vue?vue&type=script&lang=js"
import style0 from "./ModuleQuestionComponent.vue?vue&type=style&index=0&id=c8923daa&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8923daa",
  null
  
)

export default component.exports